/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { Fragment } from '@wordpress/element';
import { addFilter } from '@wordpress/hooks';

/**
 * External dependencies
 */

/**
 * Inner dependencies.
 */
import {
	ColorControl,
} from '../../../extensions/controls/color-options';
import Accordion from '../../../components/Accordion';
import blockInfo from '../constants';
const { hookPrefix } = blockInfo;

addFilter(
	`gutenify-block-${ hookPrefix }-options-tab-style`,
	`Gutenify/Block/${ hookPrefix }/InspectorControls/BasicControls/tabs/style`,
	( content, props ) => {
		const { attributes, setAttributes } = props;
		const { prefixColor, titleColor, suffixColor } = attributes;
		return [
			...content,
			<Fragment key={ `gutenify-block-${ hookPrefix }-options-tab-content-basic` }>
				<Accordion tabs={ [
					{
						name: 'colors',
						initialOpen: true,
						label: () => {
							return __( 'Colors' );
						},
						cb: () => {
							return <>
								<ColorControl
									label={ __( 'Prefix Color' ) }
									onChange={ ( color ) => {
										const data = { prefixColor: color };
										setAttributes( data );
									} }
									value={ prefixColor }
								/>
								<ColorControl
									label={ __( 'Prefix Color' ) }
									onChange={ ( color ) => {
										const data = { titleColor: color };
										setAttributes( data );
									} }
									value={ titleColor }
								/>
								<ColorControl
									label={ __( 'Suffix Color' ) }
									onChange={ ( color ) => {
										const data = { suffixColor: color };
										setAttributes( data );
									} }
									value={ suffixColor }
								/>
							</>;
						},
					},
				] } />
			</Fragment>,
		];
	}
);

